import React from "react";
import { useDispatch } from "react-redux";
import { filterActions } from "../store/filter";

function NoElements() {
  const dispatch = useDispatch();
  const handleCleanFilter = () => {
    dispatch(filterActions.filterSelected({ method: "clear" }));
  };

  return (
    <div className=" text-center relative mt-48 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 tab-port:px-12 px-8 tab-port:py-8 py-12 text-[#797979] border-2 border-dashed border-[#797979] rounded-xl">
      <p className=" tab-port:w-[12vw] tab-port:text-2xl text-4xl">
        No se ha encontrado un ítem con los filtros seleccionados, si desea
        limpiar los filtros, pulse el botón.
      </p>
      <button
        onClick={handleCleanFilter}
        className="mt-6 border-2 tab-port:px-6 px-8 py-5 tab-port:py-2 rounded-full tab-port:text-xl text-4xl  border-[#797979] hover:bg-[#003670] hover:border-transparent hover:text-white"
      >
        Limpiar Filtros
      </button>
    </div>
  );
}

export default NoElements;
